import { captureEvent } from '@lib/observability/events/captureEvent';
import 'client-only';

import { INSIGHT_ANALYTICS_EVENTS } from './constants';

export interface InsightReprocessClickedTelemetry {
  documentId: string;
  orgId: string | null;
}

export function trackInsightDocumentReprocessClicked(
  context: InsightReprocessClickedTelemetry
): void {
  captureEvent(INSIGHT_ANALYTICS_EVENTS.DOCUMENT_REPROCESS_CLICKED, {
    document_id: context.documentId,
    org_id: context.orgId,
  });
}
